module.exports = __webpack_public_path__ + "static/media/ropeHero.80e07806.png";